/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Summary_AccentInputs */

const en_us2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`closed.`);
	return /** @type {LocalizedString} */ (`closed.`)
	
};

const pt_br2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`fechado.`);
	return /** @type {LocalizedString} */ (`fechado.`)
	
};

const es_419_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`cerrado.`);
	return /** @type {LocalizedString} */ (`cerrado.`)
	
};

const pt_pt2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`fechado.`);
	return /** @type {LocalizedString} */ (`fechado.`)
	
};

const fr_fr2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`bouclé.`);
	return /** @type {LocalizedString} */ (`bouclée.`)
	
};

const de_de2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`abgeschlossen.`);
	return /** @type {LocalizedString} */ (`abgeschlossen.`)
	
};

const it_it2_wrapped_period_summary_accent = /** @type {(inputs: Wrapped_Period_Summary_AccentInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`chiuso.`);
	return /** @type {LocalizedString} */ (`chiuso.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "closed." |
* | * | "closed." |
*
* @param {Wrapped_Period_Summary_AccentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_summary_accent = /** @type {((inputs: Wrapped_Period_Summary_AccentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Summary_AccentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_summary_accent(inputs)
	if (locale === "es-419") return es_419_wrapped_period_summary_accent(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_summary_accent(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_summary_accent(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_summary_accent(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_summary_accent(inputs)
	return en_us2_wrapped_period_summary_accent(inputs)
});
export { wrapped_period_summary_accent as "wrapped-period.summary_accent" }